
import {useContext, useEffect, useState} from "react";
// @ts-ignore
import {uploadImage} from "../api/APIfunctions.tsx";
// @ts-ignore
import {loadFromStorage, storeInStorage} from "../api/LocalStorage.tsx";
// @ts-ignore
import {BoxDTO} from "../model/BoxDTO.tsx";
// @ts-ignore
import {APIContext, TabMenuContext} from "../Globals.tsx";

export default function BoxSettings(){
  const [box, setBox] = useState<BoxDTO>({});
  const [loading, setLoading] = useState<boolean>(false);
  const { saveBox } = useContext(APIContext)
  const { setActionP } = useContext(TabMenuContext)

  useEffect(() => {
    loadFromStorage("box").then((box) => {
      setBox(box);
    });
  }, []);

  useEffect(() => {
    setActionP(submit)
  }, [box]);

  function handleChange(field: string, value: string){
    setBox({...box, [field]: value});
  }
  function handleChangeAddress(field: string, value: string){
    let address = box.address
    address = {...address, [field]: value};
    setBox({...box, address});
  }

  function submit()
  {
    saveBox(box).then((e)=> {
      if(e){
        storeInStorage("box", e)
        window.location.reload()
      }
    })
  }

  return (<div className={"grid box-setting"}>
    <div className={"flex-column"}>
      <img className={"boxlogoBig"} style={{opacity: loading? 0.5: undefined}}
           src={box.photo}
           alt={"boxlogo"}/>
      <input type="file" name="photo" accept="image/*"
             onChange={(e) => {
               setLoading(true)
               uploadImage(e.target.files[0], (e, a) => console.log(e + a)).then(response => {
                 handleChange("photo", response.info);
                 setLoading(false)
               });
             }}/>
    </div>
    <div>
      <form className={"flex-column"} style={{height: "50%"}}>
        <div>
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={box.name || ""}
            onChange={(e) => handleChange("name", e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={box.email || ""}
            onChange={(e) => handleChange("email", e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="phone">Phone:</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={box.phone || ""}
            onChange={(e) => handleChange("phone", e.target.value)}
          />
        </div>
        <div className={"flex-column"}>
          <div>
            <label htmlFor="street">Straße:</label>
            <input
              type="text"
              id="street"
              name="street"
              value={box.address?.street || ""}
              onChange={(e) => handleChangeAddress("street", e.target.value)}
            />
          </div>
          <div className={"flex-row"}>
            <div>
              <label htmlFor="zip">PLZ:</label>
              <input
                type="text"
                id="zip"
                name="zip"
                value={box.address?.zip || ""}
                onChange={(e) => handleChangeAddress("zip", e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="city">Ort:</label>
              <input
                type="text"
                id="city"
                name="city"
                value={box.address?.city || ""}
                onChange={(e) => handleChangeAddress("city", e.target.value)}
              />
            </div>
          </div>
          <div>
            <label htmlFor="country">Land:</label>
            <input
              type="text"
              id="country"
              name="country"
              value={box.address?.country || ""}
              onChange={(e) => handleChangeAddress("country", e.target.value)}
            />
          </div>
        </div>
        {box?.stripePaymentKey&& <div className={"flex-column"}>
          <div>
              <label htmlFor="agb">Link zu den AGBs:</label>
              <input
                  type="text"
                  id="agb"
                  name="agb"
                  value={box.agb || ""}
                  style={{width: 350}}
                  onChange={(e) => handleChange("agb", e.target.value)}
              />
          </div>
          <div>
              <label htmlFor="name">Link zu den Datenschutzbedingungen:</label>
              <input
                  type="text"
                  id="datenschutz"
                  name="datenschutz"
                  value={box.datenschutz || ""}
                  style={{width: 350}}
                  onChange={(e) => handleChange("datenschutz", e.target.value)}
              />
          </div>
        </div>}
      </form>
    </div>
  </div>);
}
